/* eslint-disable */
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PremiumDomainRegistrar = void 0;
var json_proto_serializer_1 = require("@wix/json-proto-serializer");
var http_1 = require("@wix/ambassador/runtime/http");
var PremiumDomainRegistrar = function (baseUrl, httpClientConfig) {
    var httpClient = new http_1.AmbassadorHTTPClient(baseUrl, httpClientConfig);
    return {
        Cronulla: function () {
            return function (headers) {
                var service = {
                    autorenewDiscrepancyCheck: function (autorenewDiscrepancyCheckRequest) {
                        return httpClient.invoke('POST', '/tasks/autoRenewDiscrepancyCheck', autorenewDiscrepancyCheckRequest, headers);
                    },
                    runTucowsQueueCheck: function (tucowsQueueCheckRequest) {
                        return httpClient.invoke('POST', '/tasks/checkTucowsQueue', tucowsQueueCheckRequest, headers);
                    },
                };
                service.autorenewDiscrepancyCheck.__http_method = 'POST';
                service.autorenewDiscrepancyCheck.__http_url = '/tasks/autoRenewDiscrepancyCheck';
                service.runTucowsQueueCheck.__http_method = 'POST';
                service.runTucowsQueueCheck.__http_url = '/tasks/checkTucowsQueue';
                return service;
            };
        },
        DomainSearch: function () {
            return function (headers) {
                var service = {
                    checkDomainIfPremium: function (checkDomainIfPremiumRequest) {
                        return httpClient.invoke('GET', '/api/v1/domain-search/checkIfPremium', checkDomainIfPremiumRequest, headers);
                    },
                    checkDomainNameAvailability: function (checkDomainAvailabilityRequest) {
                        return httpClient.invoke('GET', '/api/v1/domain-search/checkAvailability', checkDomainAvailabilityRequest, headers);
                    },
                    checkDomainNameAvailabilityBulk: function (checkDomainAvailabilityBulkRequest) {
                        return httpClient.invoke('GET', '/api/v1/domain-search/checkAvailabilityBulk', checkDomainAvailabilityBulkRequest, headers);
                    },
                    suggestDomainName: function (suggestDomainRequest) {
                        return httpClient.invoke('GET', '/api/v1/domain-search/suggestDomain', suggestDomainRequest, headers);
                    },
                };
                service.checkDomainIfPremium.__http_method = 'GET';
                service.checkDomainIfPremium.__http_url = '/api/v1/domain-search/checkIfPremium';
                service.checkDomainNameAvailability.__http_method = 'GET';
                service.checkDomainNameAvailability.__http_url = '/api/v1/domain-search/checkAvailability';
                service.checkDomainNameAvailabilityBulk.__http_method = 'GET';
                service.checkDomainNameAvailabilityBulk.__http_url = '/api/v1/domain-search/checkAvailabilityBulk';
                service.suggestDomainName.__http_method = 'GET';
                service.suggestDomainName.__http_url = '/api/v1/domain-search/suggestDomain';
                return service;
            };
        },
        Registrar: function () {
            return function (headers) {
                var service = {
                    checkTransferableDomain: function (checkTransferableDomainRequest) {
                        return httpClient.invoke('POST', '/api/v1/transferRequests/{domain_name}/checkTransferableDomain', checkTransferableDomainRequest, headers);
                    },
                    checkTransferInAuthCode: function (checkTransferInAuthCodeRequest) {
                        return httpClient.invoke('POST', '/api/v1/transferRequests/{domain_name}/checkAuthCode', checkTransferInAuthCodeRequest, headers);
                    },
                    disableDnssec: function (disableDnssecRequest) {
                        return httpClient.invoke('POST', '/api/v1/registrations/{domain_name}/disableDnssec', disableDnssecRequest, headers);
                    },
                    domainBelongsToWix: function (domainBelongsToWixRequest) {
                        return httpClient.invoke('POST', '/api/v1/registrations/{domain_name}/domainBelongsToWix', domainBelongsToWixRequest, headers);
                    },
                    getRegistration: function (getRegistrationRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/api/v1/registrations/{domain_name}', getRegistrationRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['registration', 'registeredAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['registration', 'expiresAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['registration', 'icannTransferLockedUntil'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['registration', 'graceStartsAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['registration', 'redemptionStartsAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['registration', 'redemptionEndsAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['registration', 'createdAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['registration', 'icannStatusInfo', 'pending', 'deactivationDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['registration', 'redeemStartedAt'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    listRegistrations: function (listRegistrationsRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/api/v1/registrations', listRegistrationsRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['registrations', 'registeredAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['registrations', 'expiresAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['registrations', 'icannTransferLockedUntil'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['registrations', 'graceStartsAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['registrations', 'redemptionStartsAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['registrations', 'redemptionEndsAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['registrations', 'createdAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['registrations', 'icannStatusInfo', 'pending', 'deactivationDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['registrations', 'redeemStartedAt'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    listSupportedTlds: function (getSupportedTldsRequest) {
                        return httpClient.invoke('GET', '/api/v1/supportedTlds', getSupportedTldsRequest, headers);
                    },
                    sendRegistrantVerificationEmail: function (sendRegistrantVerificationEmailRequest) {
                        return httpClient.invoke('POST', '/api/v1/registrations/{domain_name}/sendRegistrantVerificationEmail', sendRegistrantVerificationEmailRequest, headers);
                    },
                    sendTransferOutEmail: function (sendTransferOutEmailRequest) {
                        return httpClient.invoke('POST', '/api/v1/registrations/{domain_name}/sendTransferOutEmail', sendTransferOutEmailRequest, headers);
                    },
                    setPrivacy: function (setPrivacyRequest) {
                        return httpClient.invoke('POST', '/api/v1/registrations/setPrivacy', setPrivacyRequest, headers);
                    },
                    updateContacts: function (updateContactsRequest) {
                        return httpClient.invoke('POST', '/api/v1/registrations/{domain_name}/updateContacts', updateContactsRequest, headers);
                    },
                };
                service.checkTransferableDomain.__http_method = 'POST';
                service.checkTransferableDomain.__http_url = '/api/v1/transferRequests/{domain_name}/checkTransferableDomain';
                service.checkTransferInAuthCode.__http_method = 'POST';
                service.checkTransferInAuthCode.__http_url = '/api/v1/transferRequests/{domain_name}/checkAuthCode';
                service.disableDnssec.__http_method = 'POST';
                service.disableDnssec.__http_url = '/api/v1/registrations/{domain_name}/disableDnssec';
                service.domainBelongsToWix.__http_method = 'POST';
                service.domainBelongsToWix.__http_url = '/api/v1/registrations/{domain_name}/domainBelongsToWix';
                service.getRegistration.__http_method = 'GET';
                service.getRegistration.__http_url = '/api/v1/registrations/{domain_name}';
                service.listRegistrations.__http_method = 'GET';
                service.listRegistrations.__http_url = '/api/v1/registrations';
                service.listSupportedTlds.__http_method = 'GET';
                service.listSupportedTlds.__http_url = '/api/v1/supportedTlds';
                service.sendRegistrantVerificationEmail.__http_method = 'POST';
                service.sendRegistrantVerificationEmail.__http_url = '/api/v1/registrations/{domain_name}/sendRegistrantVerificationEmail';
                service.sendTransferOutEmail.__http_method = 'POST';
                service.sendTransferOutEmail.__http_url = '/api/v1/registrations/{domain_name}/sendTransferOutEmail';
                service.setPrivacy.__http_method = 'POST';
                service.setPrivacy.__http_url = '/api/v1/registrations/setPrivacy';
                service.updateContacts.__http_method = 'POST';
                service.updateContacts.__http_url = '/api/v1/registrations/{domain_name}/updateContacts';
                return service;
            };
        },
        RegistrarInternal: function () {
            return function (headers) {
                var service = {
                    getDomainPrice: function (getDomainPriceRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/internal-api/v1/registrations/prices/{domain_name}', getDomainPriceRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [{ typeName: 'int64', pathInPayload: ['price', 'amount'] }];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    getRegistrationById: function (getRegistrationByIdRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/api/v2/registrations/{id}', getRegistrationByIdRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['registration', 'registeredAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['registration', 'expiresAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['registration', 'icannTransferLockedUntil'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['registration', 'graceStartsAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['registration', 'redemptionStartsAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['registration', 'redemptionEndsAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['registration', 'createdAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['registration', 'icannStatusInfo', 'pending', 'deactivationDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['registration', 'redeemStartedAt'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                };
                service.getDomainPrice.__http_method = 'GET';
                service.getDomainPrice.__http_url = '/internal-api/v1/registrations/prices/{domain_name}';
                service.getRegistrationById.__http_method = 'GET';
                service.getRegistrationById.__http_url = '/api/v2/registrations/{id}';
                return service;
            };
        },
    };
};
exports.PremiumDomainRegistrar = PremiumDomainRegistrar;
exports.PremiumDomainRegistrar.__transport = 'http';
__exportStar(require("./types"), exports);
//# sourceMappingURL=http.js.map